import styled, { createGlobalStyle } from "styled-components";
import { DefaultButton, PrimaryButton } from "@fluentui/react";

// Estilos globales para los iconos de Fluent UI
// Componente para mostrar archivo pre-cargado
export const FileInfoRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 1px solid #e1dfdd;
    border-radius: 8px;
    margin-bottom: 16px;
    gap: 12px;
    cursor: default;
`;

export const FileInfoText = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
`;

export const FileName = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #323130;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FileDetails = styled.span`
    font-size: 12px;
    color: #605e5c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const RemoveFileButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #d2d0ce;
    border-radius: 4px;
    background-color: white;
    color: #605e5c;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:hover
    {
        background-color: #f3f2f1;
        border-color: #a19f9d;
        color: #323130;
    }
    
    &:active
    {
        background-color: #edebe9;
        border-color: #8a8886;
    }
    
    &:focus
    {
        outline: none;
        border-color: #0078d4;
        box-shadow: 0 0 0 1px #0078d4;
    }
`;

// Tabla de datos importados
export const DataTableContainer = styled.div`
    border: 1px solid #e1dfdd;
    border-radius: 8px;
    overflow: hidden;
    background-color: white;
    cursor: default;
    max-height: 400px;
    display: flex;
    flex-direction: column;
`;
export const TableWrapper = styled.div`
    width: 100%;
    max-height: 300px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
`;

export const DataTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    table-layout: fixed;
`;

export const TableHeader = styled.thead``;

export const TableHeaderCell = styled.th`
    position: sticky;
    top: 0;
    background-color: #f3f2f1;
    z-index: 3;

    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #323130;
    border-bottom: 1px solid #e1dfdd;
    white-space: nowrap;

    &:first-child
    {
        width: 40%; border-right: 1px solid #e1dfdd;
    }
    &:nth-child(2)
    {
        width: 40%; border-right: 1px solid #e1dfdd;
    }
    &:last-child
    {
        width: 20%; text-align: right;
    }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    border-bottom: 1px solid #f3f2f1;

    &:hover
    {
        background-color: #f8f9fa;
    }
    &:last-child
    {
        border-bottom: none;
    }
`;

export const SummaryTableRow = styled.tr`
    border-bottom: 1px solid #efe9e9;
    background-color: #efe9e9;
    font-weight: 500;

    &:hover
    {
        background-color: #edebe9;
    }

    &:last-child
    {
        border-bottom: none;
    }
`;

export const TableCell = styled.td`
    padding: 10px 16px;
    color: #323130;
    border-right: 1px solid #f3f2f1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:first-child
    {
        width: 40%; border-right: 1px solid #e1dfdd;
    }
    &:nth-child(2)
    {
        width: 40%; border-right: 1px solid #e1dfdd;
    }
    &:last-child
    {
        width: 20%; text-align: right;
    }
`;

export const FluentUIIconFix = createGlobalStyle`
    @import url('https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/icons/fabricmdl2icons-3.70.woff');
    
    .ms-Icon,
    .ms-Button-icon .ms-Icon,
    .ms-DatePicker .ms-Icon,
    [data-icon-name] 
    {
        font-family: 'FabricMDL2Icons' !important;
        font-style: normal !important;
        font-weight: normal !important;
        speak: none !important;
        display: inline-block !important;
        text-decoration: none !important;
        text-rendering: auto !important;
        -webkit-font-smoothing: antialiased !important;
        -moz-osx-font-smoothing: grayscale !important;
    }
    
    [data-icon-name="Calendar"]
    {
        &::before
        {
            content: "\\E787" !important;
        }
    }
`;

export const ModalContainer = styled.div`
    padding: 2em 1em 1em 2em;
    background: white;
    border-radius: 8px;
`;

export const ModalTitle = styled.h2`
    margin: 0 0 0.5em 0 !important;
    font-size: 24px;
    font-weight: 600;
    color: #323130;
    cursor: default;
`;

export const ContentContainer = styled.div`
    margin: 16px 0 24px 0;
    padding: 0 16px 0 0;
`;

export const FirstRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1em;
    cursor: default;
`;

export const SecondRow = styled.div`
    display: grid;
    grid-template-columns: 30% 25% 1fr;
    align-items: center;
    margin-bottom: 1em;
    gap: 2%;
    width: 100%;
    box-sizing: border-box;
    
    @media(max-width: 1200px)
    {
        grid-template-columns: 28% 22% 1fr;
        gap: 1.5%;
    }
    
    @media(max-width: 768px)
    {
        grid-template-columns: 1fr;
        gap: 8px;
        margin-bottom: 1.5em;
    }
    
    @media (min-width: 1600px)
    {
        grid-template-columns: 32% 28% 1fr;
        gap: 2.5%;
    }
`;

export const TemplateDownload = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e1dfdd;
    width: 100%;
    box-sizing: border-box;
    gap: 6px;
    min-width: 0;
    height: 40px;
    overflow: hidden;
    
    @media(max-width: 1200px)
    {
        padding: 3px 6px;
        gap: 4px;
        height: 36px;
    }
    
    @media(max-width: 768px)
    {
        padding: 2px 4px;
        gap: 3px;
        height: 32px;
    }
    
    @media (min-width: 1600px)
    {
        padding: 5px 10px;
        gap: 8px;
        height: 44px;
    }
`;

export const TemplateLabel = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #323130;
    white-space: nowrap;
    cursor: default;
    flex-shrink: 0;
    
    @media (max-width: 1200px)
    {
        font-size: 12px;
    }
    
    @media (max-width: 768px)
    {
        font-size: 11px;
    }
    
    @media (min-width: 1600px)
    {
        font-size: 14px;
    }
`;

export const TemplateButton = styled.button`
    flex: 1;
    min-width: 0;
    max-width: 100%;
    padding: 6px 8px;
    border: 1px solid #CC214F;
    border-radius: 8px;
    font-size: 12px;
    line-height: 1.2;
    background-color: #CC214F;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    
    @media (max-width: 1200px)
    {
        font-size: 11px;
        padding: 5px 6px;
    }
    
    @media (max-width: 768px)
    {
        font-size: 10px;
        padding: 4px 5px;
    }
    
    @media (min-width: 1600px)
    {
        font-size: 13px;
        padding: 7px 10px;
    }
    
    &:hover
    {
        background-color: #CC214F;
        border-color: #CC214F;
    }
    
    &:active
    {
        background-color: #CC214F;
        border-color: #CC214F;
    }
    
    &:focus
    {
        outline: none;
        border-color: #CC214F;
        box-shadow: 0 0 0 1px #CC214F;
    }
    
    &:disabled
    {
        background-color: #f3f2f1;
        color: #a19f9d;
        border-color: #c8c6c4;
        cursor: not-allowed;
    }
`;

export const CompositionPrice = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 6px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e1dfdd;
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
    min-height: 40px;
    gap: 8px;
    padding-right: 0.75em;
`;

export const CompositionPriceLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: #323130;
    cursor: default;
    flex: 1;
    text-align: left;
`;

export const ImageElementsIA = styled.img`
    flex-shrink: 0;
    height: 18px;
    width: 18px;
    object-fit: contain;
`;

export const FileTypeSelector = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e1dfdd;
    cursor: default;
    width: 100%;
    box-sizing: border-box;
    gap: 6px;
    min-width: 0;
    min-height: 40px;
`;

export const FileTypeLabel = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #323130;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const FileTypeOption = styled.span<{ $isActive: boolean }>`
    font-size: 13px;
    color: ${props => props.$isActive ? '#0078d4' : '#605e5c'};
    font-weight: ${props => props.$isActive ? '600' : '400'};
    transition: color 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const Section = styled.div`
    margin-bottom: 24px;
    padding: 16px;
    border: 1px solid #e1dfdd;
    border-radius: 8px;
    background-color: #fafafa;
`;

export const SectionTitle = styled.h3`
    margin: 0 0 8px 0 !important;
    font-size: 16px;
    font-weight: 600;
    color: #323130;
    cursor: default;
`;

export const SectionDescription = styled.p`
    margin: 0 0 12px 0 !important;
    font-size: 12px !important;
    color: #605e5c;
    line-height: 1.25;
    cursor: default;
`;

export const FileUploadArea = styled.div`
    border: 2px dashed #c8c6c4;
    border-radius: 8px;
    padding: 24px 16px;
    text-align: center;
    background-color: white;
    transition: border-color 0.2s ease;
    cursor: pointer;
    
    &:hover
    {
        border-color: #0078d4;
        background-color: #f8f9fa;
    }
    
    &.drag-over
    {
        border-color: #0078d4;
        background-color: #deecf9;
    }
`;

export const FileUploadText = styled.div`
    font-size: 14px;
    color: #323130;
    margin-bottom: 6px;
`;

export const FileUploadSubtext = styled.div`
    font-size: 12px;
    color: #605e5c;
`;

export const SelectedFileInfo = styled.div`
    margin-top: 12px;
    padding: 8px 12px;
    background-color: #deecf9;
    border-radius: 4px;
    border-left: 4px solid #0078d4;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const OptionsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 24px;
`;

export const OptionGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const OptionLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #323130;
    margin-bottom: 8px;
`;

export const RadioOption = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
`;

export const RadioInput = styled.input`
    margin: 0;
`;

export const RadioLabel = styled.label`
    font-size: 14px;
    color: #323130;
    cursor: pointer;
`;

export const PreviewContainer = styled.div`
    margin-top: 24px;
    border: 1px solid #e1dfdd;
    border-radius: 8px;
    background-color: white;
`;

export const PreviewHeader = styled.div`
    padding: 16px 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e1dfdd;
    font-weight: 600;
    color: #323130;
`;

export const PreviewContent = styled.div`
    padding: 20px;
    max-height: 300px;
    overflow-y: auto;
`;

export const PreviewTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    
    th
    {
        background-color: #f8f9fa;
        padding: 8px 12px;
        border: 1px solid #e1dfdd;
        font-weight: 600;
        text-align: left;
    }
    
    td
    {
        padding: 8px 12px;
        border: 1px solid #e1dfdd;
    }
    
    tr:nth-child(even)
    {
        background-color: #fafafa;
    }
`;

export const ErrorMessage = styled.div`
    margin-top: 12px;
    padding: 8px 12px;
    background-color: #fdf2f2;
    border-radius: 4px;
    border-left: 4px solid #a4262c;
    color: #a4262c;
    font-size: 13px;
`;

export const WarningMessage = styled.div`
    margin-top: 12px;
    padding: 8px 12px;
    background-color: #fff8f0;
    border-radius: 4px;
    border-left: 4px solid #ffaa44;
    color: #8a6914;
    font-size: 13px;
`;

export const SuccessMessage = styled.div`
    margin-top: 16px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #f3f9f1 0%, #e8f5e8 100%);
    border-radius: 8px;
    border: 2px solid #107c10;
    color: #107c10;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 2px 8px rgba(16, 124, 16, 0.15);
    animation: successPulse 0.6s ease-in-out;
    
    @keyframes successPulse
    {
        0% { transform: scale(0.95); opacity: 0.8; }
        50% { transform: scale(1.02); opacity: 1; }
        100% { transform: scale(1); opacity: 1; }
    }
    
    @media (max-width: 768px)
    {
        padding: 12px 16px;
        font-size: 14px;
        gap: 8px;
    }
`;

export const SuccessIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #107c10;
    border-radius: 50%;
    color: white;
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
    animation: checkmark 0.5s ease-in-out;
    
    @keyframes checkmark
    {
        0% { transform: scale(0); }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); }
    }
    
    @media (max-width: 768px)
    {
        width: 20px;
        height: 20px;
        font-size: 14px;
    }
`;

export const ServerErrorMessage = styled.div`
    margin-top: 16px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #fdf2f2 0%, #fce7e7 100%);
    border-radius: 8px;
    border: 2px solid #d13438;
    color: #d13438;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 2px 8px rgba(209, 52, 56, 0.15);
    animation: errorPulse 0.6s ease-in-out;
    
    @keyframes errorPulse
    {
        0% { transform: scale(0.95); opacity: 0.8; }
        50% { transform: scale(1.02); opacity: 1; }
        100% { transform: scale(1); opacity: 1; }
    }
    
    @media (max-width: 768px)
    {
        padding: 12px 16px;
        font-size: 14px;
        gap: 8px;
    }
`;

export const ErrorIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #d13438;
    border-radius: 50%;
    color: white;
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
    animation: errorIcon 0.5s ease-in-out;
    
    @keyframes errorIcon
    {
        0% { transform: scale(0); }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); }
    }
    
    @media (max-width: 768px)
    {
        width: 20px;
        height: 20px;
        font-size: 14px;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 0 16px;
    margin-top: 32px;
`;

export const CancelButton = styled(DefaultButton)`
    background-color: #CC214F !important;
    color: white !important;
    border-color: #CC214F !important;
    min-width: 100px;
    height: 40px;
    
    &:hover
    {
        background-color: #a4262c !important;
        border-color: #a4262c !important;
    }
`;

export const ImportButton = styled(PrimaryButton)`
    min-width: 120px;
    height: 40px;
    
    &:disabled
    {
        background-color: #f3f2f1 !important;
        color: #a19f9d !important;
        border-color: #e1dfdd !important;
    }
`;

export const HiddenInput = styled.input`
    display: none;
`;

// Componente para el resumen de Elements IA
export const ElementsSummaryContainer = styled.div`
    margin-top: 16px;
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e1dfdd;
    cursor: default;
`;

export const ElementsSummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    
    @media (max-width: 768px)
    {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

export const ElementsSummaryTitle = styled.span`
    font-weight: 600;
    font-size: 14px;
    color: #323130;
    
    @media (max-width: 1200px)
    {
        font-size: 13px;
    }
    
    @media (max-width: 768px)
    {
        font-size: 12px;
    }
`;

export const ElementsSummaryCounter = styled.span<{ $isValid: boolean; $isExact: boolean; $isExceeded: boolean }>`
    font-weight: bold;
    font-size: 16px;
    padding-top: 4px;
    color: ${props => 
        props.$isExceeded ? '#d13438' : 
        props.$isExact ? '#107c10' : 
        '#605e5c'
    };
    
    @media (max-width: 1200px)
    {
        font-size: 15px;
    }
    
    @media (max-width: 768px)
    {
        font-size: 14px;
        padding-top: 2px;
    }
`;

export const ElementsSummaryMessage = styled.div<{$type: 'error' | 'success' | 'info' | 'warning'}>`
    margin-top: 8px;
    font-size: 14px;
    color: ${props =>
    {
        switch(props.$type)
        {
            case 'error': return '#d13438';
            case 'success': return '#107c10';
            case 'warning': return '#8a6914';
            case 'info': 
            default: return '#605e5c';
        }
    }};
    
    @media (max-width: 1200px)
    {
        font-size: 13px;
    }
    
    @media (max-width: 768px)
    {
        font-size: 12px;
        margin-top: 6px;
    }
`;

export const PortfolioModelModificationContainer = styled.div`
    margin: 16px 0;
    padding: 1em;
    background-color: #FFC107;
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    cursor: default;
`;

export const ModificationToggleContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    .ms-Toggle
    {
        display: flex;
        align-items: center;
        
        .ms-Toggle-innerContainer
        {
            display: flex;
            align-items: center;
        }
        
        .ms-Toggle-label
        {
            display: flex;
            align-items: center;
            margin-left: 12px;
        }
    }
`;

export const ModificationLabel = styled.label`
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #323130;
    margin: 0;
`;

export const ModificationInfoText = styled.p`
    font-size: 12px;
    color:#323130;
    margin: 0;
    line-height: 1.4;
    cursor: default;
    padding-top: 0.5em;
`;